import React from "react";

export default function Label(props) {
    let { style = {}, width = 0, className = "", grow = false, shrink = true, onClick = () => {} } = props;
    if (width) { style.width = width + "px"; }
    if(grow){
        style.flexGrow = 1; 
    } else {
        style.flexGrow = 0;
    }

    if(!shrink){
        style.flexShrink = 0;
    }
    let _class = "ui-label";
    if (className) { _class += " " + className; }

    return (<div onClick={onClick} style={{ ...style }} className={_class}>{props.children}</div>)
}

export function DisplayLabel(props) {
    let { style = {}, width = 0, className = "", value="" } = props;
    if (width) { style.width = width + "px"; }

    let _class = "ui-display-label";
    if (className) { _class += " " + className; }

    if(value){
         return (<div style={{ ...style }} className={_class}>{value}</div>)
    }

    return (<div style={{ ...style }} className={_class}>{props.children}</div>)
}